import { IAdminWork } from '../../types/adminWork';
import GeneralEnumService from '../../enumerables/general-enum';
import { getValFromEnum } from '../../components/redux-form/utils/dropdown-values';
import moment from 'moment';
import { changeToZeroMoment } from '../timeHelpers';
import { numberWithCommas } from '../format';

export const groupDataToCsv = (data: IAdminWork[]): string[][] => {
    const groupData: string[][] = [
        [
            'Date',
            'Provider',
            'Start Time',
            'End Time',
            'Total Hours',
            'Admin Rate per Hour',
            'Total',
            'Comment',
            'Status',
        ],
    ];
    const GeneralEnum = GeneralEnumService ? GeneralEnumService.getEnum('AdminWorkStatus') : {};
    const statusItems: SelectObject[] = getValFromEnum(GeneralEnum);
    let sumAmount = 0;
    let sumAdminRate = 0;
    let sumHours = 0;
    data.forEach((it) => {
        const adminWorkDate = it.adminWorkDate ? moment(it.adminWorkDate).format('MMM D, YYYY') : '';
        const providerTitle: string = it?.provider?.fullName ? `${it.provider.fullName}` : '';
        const endTime = it['endTime'] ? changeToZeroMoment(it['endTime'], 'LT') : '';
        const startTime = it['startTime'] ? changeToZeroMoment(it['startTime'], 'LT') : '';
        const description: string = it?.description ? `${it.description}` : '';
        const totalAmount: string = it?.totalAmount ? `${it.totalAmount}` : '0';
        const adminRate: string = it?.adminRate ? `${it.adminRate}` : '0';
        const totalHours: string = it?.totalHours ? `${it.totalHours}` : '0';

        sumAmount += +totalAmount;
        sumAdminRate += +adminRate;
        sumHours += +totalHours;
        let valuestatus: string | SelectObject | undefined = statusItems.find((its) => +its.value === +it.status);
        valuestatus = valuestatus ? `${valuestatus?.label}` : '';

        groupData.push([
            adminWorkDate,
            providerTitle,
            startTime,
            endTime,
            totalHours,
            `$${numberWithCommas(adminRate)}`,
            `$${numberWithCommas(totalAmount)}`,
            description,
            valuestatus,
        ]);
    });

    groupData.push([
        '',
        '',
        '',
        '',
        `${sumHours}`,
        `$${numberWithCommas(sumAdminRate)}`,
        `$${numberWithCommas(sumAmount)}`,
        '',
        '',
    ]);

    return groupData;
};
